import { AVProfessionalProject, AVProfessional, AVProject } from "../types/entities";

export const mapProfessional = (professionalProjects: AVProfessionalProject[]): AVProfessional => {
  if (!professionalProjects) {
    return {
      ID: 0,
      CodeAV: '',
      FirstName: '',
      LastName: '',
      UserID: ''
    }
  }
  return {
    ID: professionalProjects[0].ID,
    Email: professionalProjects[0].Email,
    CodeAV: professionalProjects[0].CodeAV,
    FirstName: professionalProjects[0].FirstName,
    LastName: professionalProjects[0].LastName,
    UserID: professionalProjects[0].UserID
  }
}

export const mapProjects = (professionalProjects: AVProfessionalProject[]): AVProject[] => {
  if (!professionalProjects[0].PRJID) {
    return []
  }
  return professionalProjects.map(project => ({
    ID: project.PRJID,
    ProjectCode: project.ProjectCode,
    HoursCostCode: project.HoursCostCode,
    ExpensesCostCode: project.ExpensesCostCode,
    ProjectType: project.ProjectType,
    ExpensesReimbursed: project.ExpensesReimbursed,
    TravelReimbursed: project.TravelReimbursed,
    ExpensesDeductible: project.ExpensesDeductible,
    TravelDeductible: project.TravelDeductible,
    TravelExpensesDeductible: project.TravelExpensesDeductible,
    PaidLeave: project.PaidLeave,
    UnitType: project.UnitType,
    StartDate: project.StartDate,
    EndDate: project.EndDate,
    CutoffPoint: project.CutoffPoint,
    ApproverID: project.ApproverID,
    ApproverName: project.ApproverName,
    Approvers: project.Approvers,
    MagnoEntity: project.MagnoEntity,
    Supplier: project.Supplier,
    MaxDeductibleTravel: project.MaxDeductibleTravel,
    ClientCode: project.ClientCode,
    ExactSupplierCode: project.ExactSupplierCode,
    MIPProjectCode: project.MIPProjectCode
  }))
}
